import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AcademiaResponse } from '../../../types/common';
import { RetainAgreement } from '../../../types/retain';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const useRetainAgreementActions = (whichAction: 'retainAgreementList' | '') => {
  // query function to fetch retain agreement list declared here
  const getRetainAgreementListHandler = useQuery({
    queryKey: ['retain-agreement-list'],
    queryFn: async (): Promise<AcademiaResponse<Array<RetainAgreement>>> => {
      const response = await getPrivateAxiosInstance('appointment').get(
        '/retainer/agreement/list/'
      );

      return response.data;
    },

    ...returnQueryConfig(whichAction === 'retainAgreementList'),
  });

  // mutation function to create new retain agreement declared here
  const createNewRetainAgreementHandler = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: FormData;
    }): Promise<AcademiaResponse<RetainAgreement>> => {
      const response = await getPrivateAxiosInstance('appointment').post(
        '/retainer/agreement/create/',
        body
      );

      return response.data;
    },
  });

  // mutation function to update retain agreement by id declared here
  const updateRetainAgreementByIdHandler = useMutation({
    mutationFn: async ({
      agreementId,
      body,
    }: {
      agreementId: number;
      body: FormData;
    }): Promise<AcademiaResponse<RetainAgreement>> => {
      const response = await getPrivateAxiosInstance('appointment').patch(
        `/retainer/agreement/${agreementId}/partial/update/`,
        body
      );

      return response.data;
    },
  });

  // mutation function to delete retain agreement by id declared here
  const deleteRetainAgreementByIdHandler = useMutation({
    mutationFn: ({
      agreementId,
    }: {
      agreementId: number;
    }): Promise<AxiosResponse<AcademiaResponse<null>>> =>
      getPrivateAxiosInstance('appointment').delete(
        `/retainer/agreement/${agreementId}/delete/`
      ),
  });

  return {
    getRetainAgreementListHandler,
    createNewRetainAgreementHandler,
    updateRetainAgreementByIdHandler,
    deleteRetainAgreementByIdHandler,
  };
};

export default useRetainAgreementActions;
